import React from 'react';

const ConsentBlackbar = () => {
    return <div id="consent_blackbar"></div>
}

export default ConsentBlackbar;